import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonCloudStudioModule, ENVIRONMENT } from 'common-cloudstudio';
import { MapService } from 'src/app/shared/services/map.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MapTabsComponent } from 'src/app/customer-modules/apolus/maps/map-tabs/map-tabs.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AlarmsMapComponent } from 'src/app/customer-modules/apolus/maps/alarms-map/alarms-map.component';
import { CustomMapComponent } from 'src/app/customer-modules/apolus/maps/custom-map/custom-map.component';


declare var environment;

export function environmentFactory(): any {
  return environment;
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    GoogleMapsModule,
  ],
  declarations: [MapTabsComponent, AlarmsMapComponent, CustomMapComponent],
  exports: [MapTabsComponent, AlarmsMapComponent, CustomMapComponent],
  providers: [MapService, { provide: ENVIRONMENT, useFactory: environmentFactory },]
})
export class MapsCustomModule { }
